class ServiceContainerException extends Error {}

export default ServiceContainerException;
